export default __webpack_public_path__ + "static/Seo3-c5ba333bfca96400b80a4683043567fc.jpg";